import * as z from "zod";
import { gql } from "graphql-request";

import { Sys, SysFragment } from "../sys";
import { Image, ImageFragment } from "../image";
import { UnifiedButton, UnifiedButtonFragment } from "../unifiedButton";

export const FullscreenEntryCarousel = z.object({
  sys: Sys,
  __typename: z.literal("FullscreenEntryCarousel"),
  expirationDate: z.string().nullable(),
  readMoreButton: UnifiedButton.nullish(),

  body: z
    .object({
      json: z.unknown(),
    })
    .nullish(),
  backgroundMedia: Image.nullable(),
  backgroundMediaEn: Image.nullable(),
});

export type FullscreenEntryCarousel = z.infer<typeof FullscreenEntryCarousel>;

export const FullscreenEntryCarouselFragment = gql`
  fragment FullscreenEntryCarouselFragment on FullscreenEntryCarousel {
    __typename
    sys {
      ...SysFragment
    }

    expirationDate

    readMoreButton {
      __typename
      ... on UnifiedButton {
        ...UnifiedButtonFragment
      }
    }

    body {
      json
    }

    backgroundMedia {
      ...ImageFragment
    }

    backgroundMediaEn: backgroundMedia(locale: "en") {
      ...ImageFragment
    }
  }

  ${SysFragment}
  ${UnifiedButtonFragment}
  ${ImageFragment}
`;
